import React from 'react';
import { Box, TextField, Stack } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';

import * as ShopSelectors from 'selectors/ShopSelectors';
import CollapseSection from '../components/CollapseSection';
import { FormValues } from '../types';
import EyeButton from '../components/EyeButton';
import { useTranslation } from 'services/localization';
import { getCustomizerLocaleOnChange } from '../utils';
import CustomSection from '../components/CustomContent';

const AboutPage = () => {
	const { t } = useTranslation();
	const { control, watch } = useFormContext<FormValues>();
	const defaultLanguage = useSelector(ShopSelectors.activeShopDefaultLanguage);

	const hidden = watch('onlineLayout.about.hidden');
	const textContent = watch('onlineLayout.about.textContent');

	return (
		<>
			<CollapseSection
				heading={t('channels.online.customizer.section', 'Section')}
				id="about-page-section"
			>
				<Box mt={3}>
					<Controller
						name="onlineLayout.about.heading"
						control={control}
						render={({ field }) => {
							return (
								<TextField
									{...field}
									label={t('channels.online.customizer.aboutPage.headingInputLabel', 'Heading')}
									placeholder={t(
										'channels.online.customizer.aboutPage.headingInputPlaceholder',
										'About',
									)}
									InputLabelProps={{
										shrink: true,
									}}
									fullWidth
									value={field.value?.def}
									onChange={(event) =>
										field.onChange(
											getCustomizerLocaleOnChange(event.target.value, field.value, defaultLanguage),
										)
									}
								/>
							);
						}}
					/>
				</Box>
				<Box mt={3}>
					<Stack direction="row" justifyContent="end">
						<Controller
							name="onlineLayout.about.hidden"
							control={control}
							render={({ field }) => (
								<EyeButton
									disabled={!textContent}
									visible={field.value ?? false}
									onChange={(visible) => {
										field.onChange(!visible);
									}}
								/>
							)}
						/>
					</Stack>
					<Controller
						name="onlineLayout.about.textContent"
						control={control}
						render={({ field }) => (
							<TextField
								{...field}
								label={t('channels.online.customizer.aboutPage.textContentLabel', 'Content')}
								placeholder={t(
									'channels.online.customizer.aboutPage.textContentPlaceholder',
									'Add content',
								)}
								disabled={hidden}
								value={field.value?.def}
								InputLabelProps={{
									shrink: true,
								}}
								fullWidth
								multiline
								rows={10}
								onChange={(event) =>
									field.onChange(
										getCustomizerLocaleOnChange(event.target.value, field.value, defaultLanguage),
									)
								}
							/>
						)}
					/>
				</Box>
			</CollapseSection>
			<Stack mt={3} spacing={2}>
				<CustomSection />
			</Stack>
		</>
	);
};

export default AboutPage;
